import {gql} from 'apollo-angular';

export const createUserMutation = gql`
    mutation Create_customer($row: CustomerInput!) {
      create_customer(row: $row) {
        id
        name
        email
        mobile_number
      }
    }
`;


export const createOrderCustomerDetail = gql`
    mutation Create_order_customer_detail($row: OrderCustomerDetailInput!) {
      create_order_customer_detail(row: $row) {
        customer_id
        customer_email
        customer_name
        customer_number
      }
    }
`;

export const CREATE_ADDRESS = gql`
  mutation Mutation($row: AddressInput!) {
    create_address(row: $row) {
      id
      city
      country
      land_mark
      locality
      name
      pin_code
      state
      street
    }
  }
`;

export const CREATE_CUSTOMER_ADDRESS = gql`
  mutation Mutation($row: CustomerAddressInput!) {
    create_customer_address(row: $row) {
      id
    }
  }
`;

export const UPDATE_ADDRESS = gql`
  mutation Mutation($updateAddressId: UUID!, $change: AddressInput!) {
  update_address(id: $updateAddressId, change: $change) {
    id
    city
    country
    land_mark
    locality
    name
    pin_code
    state
    street
  }
}`;

export const USER_UPDATE = gql`
  mutation Update_user($updateUserId: UUID!, $change: UserInput!) {
    update_user(id: $updateUserId, change: $change) {
      fcm_token
    }
  }`;


export const CREATE_CUSTOMER_RATING = gql`
  mutation Create_customer_rating($row: CustomerRatingInput!) {
    create_customer_rating(row: $row) {
      id
    }
  }`;


export const DELETE_CUSTOMER_ADDRESS = gql`
    mutation Mutation($id: UUID!) {
      delete_customer_address(id: $id) {
        id
      }
    }`;

export const DELETE_ADDRESS = gql`
    mutation Mutation($id: UUID!) {
      delete_address(id: $id) {
        id
      }
    }`;
